<template>
    <v-layout row>
        <v-flex xs4 class="pr-3">
            <v-select
                autocomplete
                :disabled="disabled && !!model.id"
                v-if="!isSub"
                :placeholder="$t('label.approverType')"
                v-bind:items="types"
                v-model="type"
                :rules="rules.type"
                :no-data-text="$t('message.warning.noData')"
            ></v-select>
            <v-icon v-else style="float: right"
                >subdirectory_arrow_right</v-icon
            >
        </v-flex>
        <v-flex xs6>
            <v-select
                autocomplete
                :placeholder="$t('label.person')"
                v-bind:items="persons"
                v-model="person"
                :rules="rules.person"
                :no-data-text="$t('message.warning.noData')">
                <template #selection="{ item }">
                    <div :style="backgroundAlteracao" :title="msgAlt" >{{item.text}}</div>
                </template>
            </v-select>
        </v-flex>
        <v-flex xs1 class="pa-2">
            <v-icon
                v-if="!disabled || !model.id"
                @click="remove"
                style="cursor:pointer"
                >delete</v-icon
            >
        </v-flex>
        <v-flex xs1 class="pa-2">
            <v-icon
                v-if="!disabled || !!model.id"
                @click="addSub"
                style="cursor:pointer"
                >add</v-icon
            >
        </v-flex>
    </v-layout>
</template>

<script>
import utilities from "@/helpers/utilities";
import validation from "@/helpers/validation";

export default {
    props: {
        model: {
            type: Object,
            required: true,
            default: {}
        },
        list: {
            type: Array,
            required: false,
            default: []
        },
        disabled: {
            type: Boolean,
            required: false,
            default: false
        },
        isSub: {
            type: Boolean,
            required: false,
            default: false
        },
        office: {
            type: Number,
            required: true
        },
        msgAlt: {
            type: String,
            required: false,
            default: ""
        }
    },

    data() {
        return {
            type: this.model.type.id,
            person: this.model.person.id,

            rules: {
                type: [
                    ...validation.required,
                    () =>
                        this.list.filter(
                            item =>
                                item.uuid !== this.model.uuid &&
                                item.type.id === this.type &&
                                !this.isSub &&
                                !item.isSub
                        ).length === 0 || this.$t("message.validation.unique")
                ],
                person: [...validation.required]
            }
        };
    },

    computed: {
        types() {
            const tFilter = this.$store.getters.approverTypes
                            .filter(type => type.officeId === this.office);

            const tFormat = tFilter.map(({ id, name, isActive }) => ({
                value: id,
                text: name,
                isActive,
            }));

            return utilities.combobox(
                tFormat,
                this.type
            );
        },
        persons() {
            return this.getPersonHiredAndOffice();
        },
        backgroundAlteracao() {
            if (this.msgAlt !== '' && this.msgAlt.indexOf('todos') > -1) {
                return { color: 'red' };
            } else if (this.msgAlt !== '') {
                return { color: 'green' };
            }

            return { color: 'black' };
        }
    },

    watch: {
        type: "update",
        person: "update"
    },

    methods: {
        update() {
            this.$emit("change", {
                id: this.model.id,
                type: { id: this.type },
                person: { id: this.person },
                uuid: this.model.uuid,
                isSub: this.model.isSub
            });
        },
        remove() {
            this.$emit("remove", this.model.uuid);
        },
        addSub() {
            this.$emit("sub", this.model);
        },
        getPersonHiredAndOffice() {
            if (this.$store.getters.profile.person.isHired) {
                const p = this.$store.getters.persons;
                const pFilter = p.filter(
                            person =>
                                person.isActive &&
                                ((!!person.office &&
                                person.office.id === this.office) || person.isHired)
                );
                return pFilter.map(({ id, username, name }) => ({
                    value: id,
                    text: `${username} - ${name}`
                }));
            }
            return this.$store.getters.personsNotHiredSomeOfficeProfileValueText;
        }
    }
};
</script>



// WEBPACK FOOTER //
// src/components/systems/Approver.vue